function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M43.8,0C38,0,32.9,3,30,7.6C27.1,3,22,0,16.2,0C7.3,0,0,7.3,0,16.3c0,5.3,3,9.5,6.5,13L30.8,55l26.6-30 c2.2-3.4,2.6-5.5,2.6-8.7C60,7.3,52.7,0,43.8,0z M55,23.1L30.8,50.6C8.7,27.2,8.7,27.2,8.6,27.1C4.8,23.3,3,19.8,3,16.3 C3,9,8.9,3,16.2,3c4.6,0,8.8,2.3,11.2,6.2l2.5,4l2.5-4C35,5.3,39.2,3,43.8,3C51.1,3,57,8.9,57,16.2C57,18.8,56.8,20.3,55,23.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M36.2,23l1.9-1.9L36,19l-1.9,1.9c-0.8-0.5-1.6-0.9-2.6-1.1v-2.7h-3v2.7c-1,0.2-1.8,0.6-2.6,1.1L24,19.1 l-2.1,2.1l1.9,1.9c-0.5,0.8-0.9,1.7-1.1,2.6H20v3h2.7c0.2,0.9,0.6,1.8,1.1,2.6l-1.9,1.9l2.1,2.1l1.9-1.9c0.8,0.5,1.7,0.9,2.7,1.1 v2.6h3v-2.6c1-0.2,1.9-0.6,2.7-1.1l1.9,1.9l2.1-2.1l-1.9-1.9c0.5-0.8,0.9-1.6,1.1-2.6H40v-3h-2.7C37.1,24.7,36.8,23.8,36.2,23z  M25.5,27.2c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5s-2,4.5-4.5,4.5S25.5,29.7,25.5,27.2z"
}));

var SvgHeartSettings = function SvgHeartSettings(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 55",
    style: {
      enableBackground: "new 0 0 60 55"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/heart-settings.5542d010.svg";
export { SvgHeartSettings as ReactComponent };